import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehicleanalyzereport/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const searchByName = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehicleanalyzereport/searchbyname/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehicleanalyzereport/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehicleanalyzereport/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehicleanalyzereport/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const exportExcel = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehicleanalyzereport/exportexcel' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const deleteByAnalyzeDatetimeRange = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehicleanalyzereport/deletebyanalyzedatetimerange/' + params.start + '/' + params.end + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const anlyze = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehicleanalyzereport/anlyze/' + params.selectTime + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

